import { render, staticRenderFns } from "./gongshang.vue?vue&type=template&id=55cb639e&scoped=true"
import script from "./gongshang.vue?vue&type=script&lang=js"
export * from "./gongshang.vue?vue&type=script&lang=js"
import style0 from "./gongshang.vue?vue&type=style&index=0&id=55cb639e&prod&scoped=true&lang=less"
import style1 from "./gongshang.vue?vue&type=style&index=1&id=55cb639e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb639e",
  null
  
)

export default component.exports